module.exports = __webpack_public_path__ + "img/step8.f82aae3d.png";